export default "__VITE_ASSET__aLCEeVQl__"